import React from 'react';

// 에러 바운더리 컴포넌트 (React 디버깅 도구)
// 컴포넌트에서 에러가 발생했을 때 잡아서 보여주는 컴포넌트
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  // 에러가 발생했을 때 호출되는 메서드
  static getDerivedStateFromError(error) {
    // 다음 렌더링에서 에러 UI를 보여주기 위해 상태를 업데이트
    return { hasError: true };
  }

  // 에러 정보를 로깅
  componentDidCatch(error, errorInfo) {
    // 에러 정보를 콘솔에 출력 (디버깅용)
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // 에러 정보를 상태에 저장
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // 에러가 발생했을 때 보여줄 UI
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>⚠️ 에러가 발생했습니다!</h2>
          <details style={{ marginTop: '20px', textAlign: 'left' }}>
            <summary>에러 상세 정보 (클릭하여 확인)</summary>
            <pre style={{ 
              background: '#f5f5f5', 
              padding: '10px', 
              overflow: 'auto',
              marginTop: '10px'
            }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </pre>
          </details>
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#282c34',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            페이지 새로고침
          </button>
        </div>
      );
    }

    // 정상적으로 렌더링
    return this.props.children;
  }
}

export default ErrorBoundary;

